export const primaryNavigation = [
  { label: "Services", href: "/studio" },
  { label: "Inspiration", href: "/#portfolio" },
];

export const inquiryNavigation = { label: "Inquire", href: "/studio#contact" };
